export const DAMENKOM_REGISTRATION_NUMBER = "7028210065";
export const DAMENKOM_ATTESTATION_NUMBER = "0000324597";
export const MOBILE_BREAKPOINT = 768;
